module.exports = __webpack_public_path__ + "48c5e0b93719092f3b48b34405557629.MP3";